import React from 'react';
import './RoleSections.css';
import useRevealOnScroll from '../utils/useRevealOnScroll';

export function RoleFeatureGridSection({ id, eyebrow, title, lead, items }) {
  const { ref, isVisible } = useRevealOnScroll({ rootMargin: '0px 0px -8% 0px' });

  return (
    <section
      id={id}
      className={isVisible ? 'section roleSec reveal isVisible' : 'section roleSec reveal'}
      ref={ref}
    >
      <div className="container">
        <div className="roleSecHead">
          <div>
            {eyebrow ? <div className="roleEyebrow">{eyebrow}</div> : null}
            <h2 className="sectionTitle">{title}</h2>
            {lead ? <p className="sectionLead">{lead}</p> : null}
          </div>
        </div>

        <div className="roleSecGrid">
          {items.map((it) => (
            <div className="roleSecCard" key={it.title}>
              <div className="roleSecIcon" aria-hidden="true">
                {it.icon}
              </div>
              <div className="roleSecTitle">{it.title}</div>
              <div className="roleSecText">{it.text}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RoleStepsSection({ id, eyebrow, title, lead, steps }) {
  const { ref, isVisible } = useRevealOnScroll({ rootMargin: '0px 0px -8% 0px' });

  return (
    <section
      id={id}
      className={isVisible ? 'section roleSec roleSteps reveal isVisible' : 'section roleSec roleSteps reveal'}
      ref={ref}
    >
      <div className="container">
        <div className="roleSecHead">
          <div>
            {eyebrow ? <div className="roleEyebrow">{eyebrow}</div> : null}
            <h2 className="sectionTitle">{title}</h2>
            {lead ? <p className="sectionLead">{lead}</p> : null}
          </div>
        </div>

        <div className="stepsGrid" role="list">
          {steps.map((s, idx) => (
            <div className="stepCard" key={s.title} role="listitem">
              <div className="stepNum" aria-hidden="true">
                {idx + 1}
              </div>
              <div>
                <div className="stepTitle">{s.title}</div>
                <div className="stepText">{s.text}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function RoleCTASection({ id, title, lead, bullets = [], primary, secondary }) {
  const { ref, isVisible } = useRevealOnScroll({ rootMargin: '0px 0px -8% 0px' });

  return (
    <section
      id={id}
      className={isVisible ? 'section roleCta reveal isVisible' : 'section roleCta reveal'}
      ref={ref}
    >
      <div className="container">
        <div className="roleCtaCard">
          <div className="roleCtaLeft">
            <h2 className="roleCtaTitle">{title}</h2>
            {lead ? <p className="roleCtaLead">{lead}</p> : null}

            {bullets.length ? (
              <div className="roleCtaBullets">
                {bullets.map((b) => (
                  <div className="roleCtaBullet" key={b}>
                    <span className="roleCtaCheck" aria-hidden="true" />
                    {b}
                  </div>
                ))}
              </div>
            ) : null}
          </div>

          <div className="roleCtaRight">
            <div className="roleCtaActions">
              {primary ? (
                <a className="btn btnPrimary roleCtaBtn" href={primary.href}>
                  {primary.label}
                </a>
              ) : null}
              {secondary ? (
                <a className="btn btnGhost roleCtaBtn" href={secondary.href}>
                  {secondary.label}
                </a>
              ) : null}
            </div>
            <div className="roleCtaHint">Tip: you can always go back to the main landing page to explore more.</div>
          </div>
        </div>
      </div>
    </section>
  );
}
